/* Broadcast 6.1.0 — MegaNav を“クリックのみ開閉”に統一 + パンくず制御 */
(() => {
  const TAG = 'hover-disclosure';
  const VISIBLE = 'is-visible';
  const PANEL_SEL = '.header__dropdown';
  const WRAP_VISIBLE = 'meganavVisible';

  const BC_SEL = '.new-breadcrumbs';
  const BC_HIDDEN = 'is-hidden';

  /* ================= A) クリックのみで開閉（hoverは無効） ================ */
  function installClickOnly() {
    const C = customElements.get(TAG);
    if (!C) return;

    // クリックトークン方式：クリック時にだけ開ける
    C.prototype.showDisclosure = function () {
      if (!this.__clickToken) return; // ← hover等の呼び出しは無効化
      this.__clickToken = false; // 1回使い切り
      const panel = this.disclosure || this.querySelector(PANEL_SEL);
      if (!panel) return;
      this.wrapper?.classList.add(WRAP_VISIBLE);
      this.setAttribute('aria-expanded', 'true');
      this.classList.add(VISIBLE);
      panel.classList.add(VISIBLE);
    };

    C.prototype.hideDisclosure = function () {
      const panel = this.disclosure || this.querySelector(PANEL_SEL);
      if (!panel) return;
      this.setAttribute('aria-expanded', 'false');
      this.classList.remove(VISIBLE);
      panel.classList.remove(VISIBLE);
      // 他に開いているものが無ければ wrapper を戻す
      if (!document.querySelector(`${TAG}.${VISIBLE}`)) {
        this.wrapper?.classList.remove(WRAP_VISIBLE);
      }
    };

    // クリック委譲（常に1つだけ開く／外側クリック・ESCで閉じる）
    if (!window.__NAV_CLICK_ONLY_BOUND__) {
      window.__NAV_CLICK_ONLY_BOUND__ = true;

      document.addEventListener(
        'click',
        (e) => {
          // 修飾キーは通常遷移
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

          const path = e.composedPath ? e.composedPath() : [e.target];
          const hd = path.find((n) => n && n.tagName === TAG.toUpperCase());
          if (!hd) {
            // 外側クリック → 全閉じ
            document
              .querySelectorAll(`${TAG}.${VISIBLE}`)
              .forEach((el) => el.hideDisclosure && el.hideDisclosure());
            return;
          }

          // パネル内クリックは通常遷移（子リンクはそのまま動作）
          const panel = hd.disclosure || hd.querySelector(PANEL_SEL);
          if (panel && (panel.contains(e.target) || path.includes(panel)))
            return;

          // トップトリガのクリックは開閉トグル
          e.preventDefault();
          const open = hd.classList.contains(VISIBLE);
          if (open) {
            hd.hideDisclosure && hd.hideDisclosure();
          } else {
            document
              .querySelectorAll(`${TAG}.${VISIBLE}`)
              .forEach(
                (el) => el !== hd && el.hideDisclosure && el.hideDisclosure()
              );
            hd.__clickToken = true; // ← クリックでだけ許可
            hd.showDisclosure && hd.showDisclosure();
          }
        },
        true
      );

      document.addEventListener(
        'keydown',
        (e) => {
          if (e.key !== 'Escape') return;
          document
            .querySelectorAll(`${TAG}.${VISIBLE}`)
            .forEach((el) => el.hideDisclosure && el.hideDisclosure());
        },
        true
      );
    }
  }

  // すでに定義済みなら即パッチ、未定義なら define 後に適用
  const existing = customElements.get(TAG);
  if (existing) installClickOnly();
  const origDefine = customElements.define.bind(customElements);
  customElements.define = function (name, Ctor, opts) {
    const r = origDefine(name, Ctor, opts);
    if (name === TAG) installClickOnly();
    return r;
  };

  /* ================= B) パンくず制御（開→即非表示／閉→遅延復帰） ================ */
  document.addEventListener('DOMContentLoaded', () => {
    const bc = document.querySelector(BC_SEL);
    if (!bc) return;

    const dropdowns = Array.from(document.querySelectorAll(PANEL_SEL));

    const getMaxTransitionMs = () => {
      let max = 0;
      dropdowns.forEach((el) => {
        const cs = getComputedStyle(el);
        const durs = cs.transitionDuration
          .split(',')
          .map((v) => parseFloat(v) || 0);
        const maxS = Math.max(...durs, 0);
        if (maxS > max) max = maxS;
      });
      return max * 1000; // 秒→ms
    };

    let timer = null;
    const refresh = () => {
      const anyOpen = dropdowns.some((el) => el.classList.contains(VISIBLE));
      clearTimeout(timer);
      if (anyOpen) {
        bc.classList.add(BC_HIDDEN); // 開いたら即非表示
      } else {
        const delay = getMaxTransitionMs(); // CSSのフェード時間分だけ待つ
        timer = setTimeout(() => bc.classList.remove(BC_HIDDEN), delay);
      }
    };

    // クラス変化を監視
    dropdowns.forEach((el) => {
      new MutationObserver(refresh).observe(el, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });
    refresh();
  });
})();
